<script>
  import Layout from '@layouts/main.vue'
  import Options from '@components/analytics/Options/Options.vue'
  import Stats from '@components/analytics/Stats/Stats.vue'
  import Responses from '@components/analytics/Responses/Responses.vue'
  import { mapState } from 'vuex'
  import appConfig from '@src/app.config.json'

  export default {
    page: {
      title: 'Analytics',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    name: 'AnalyticsView',
    components: {
      Layout,
      'stats-options-component': Options,
      'stats-overview-component': Stats,
      'responses-overview-component': Responses,
    },
    data: function() {
      return {
        showStats: true,
      }
    },
    computed: {
      ...mapState({
        getStatsCompleted: (state) => state.campaign.analytics.stats.getStatsCompleted,
        targetCampaignUUID: (state) => state.campaign.targetCampaignUUID,
      }),
    },
    watch: {
      showStats(value) {
        if (!value) {
          /* eslint-disable */
          this.$router.replace({
            name: "analytics",
            query: { ...this.$route.query, type: 'responses' }
          }).catch(err => {
            // Hacky way to prevent navigationDuplicate vue router error
          })
          /* eslint-enable */
        } else {
          this.$router.replace({ name: "analytics" })
        }
      },
    },
    created() {
      if (this.$route.query.type === 'responses') {
        this.showStats = false
      }
    },
  }
</script>

<template>
  <Layout>
    <el-row :class="$style.analyticsView">
      <el-col :span="24" :md="{ span: 22, offset: 1 }">
        <el-row type="flex" justify="space-between" align="middle">
          <el-col :xs="24" :sm="12">
            <h1 class="has-subheading">Analytics</h1>
            <span v-if="!targetCampaignUUID" class="ml-4 px-2 py-0.5 inline-block bg-onvocado-secondary-light text-sm rounded">
              Sample Data
            </span>
            <p>Detailed overview of campaign interactions</p>
          </el-col>

          <el-col :xs="24" :sm="12" style="text-align: right">
            <el-radio-group v-model="showStats"
                            :class="$style.elRadioGroup"
                            :disabled="!targetCampaignUUID"
                            fill="#0f2815"
                            text-color="#ffffff"
                            size="medium">
              <el-radio-button :label="true">Stats</el-radio-button>
              <el-radio-button :label="false">Responses</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>

        <el-container class="container-lg">
          <el-header height="auto">
            <h4>Campaign</h4>
            <stats-options-component v-if="getStatsCompleted"
                                     :show-stats="showStats"></stats-options-component>
          </el-header>

          <el-main>
            <stats-overview-component v-if="showStats"></stats-overview-component>

            <responses-overview-component v-else></responses-overview-component>
          </el-main>

        </el-container>
      </el-col>
    </el-row>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

  .analyticsView {
    input {
      border: 0;
    }
  }

  .elRadioGroup {
    padding: 0 20px;
  }
</style>
